import React from 'react';

import { generateId } from '@repo/utils';
import SupportCard from '../../../tailwind/SupportCard';
import RichText from '@repo/ui-components/dept/molecules/RichText';

interface ProductDetailsProps {
  block: {
    contentBlocks: {
      _key: string;
      block: {
        _type: string;
        rows: { cells: string[] }[];
        children: { text: string }[];
      }[];
      contentType: string;
      headline: string;
      html: string;
      image: {
        asset: {
          alt?: string;
          url: string;
        };
      };
    }[];
    supportBlockDisabled: boolean;
  };
  data: {
    product: {
      supportPage: string;
      warnings: {
        _key: string;
        warning: { block: any };
      }[];
      warranties: {
        _key: string;
        warranty: { block: any };
      }[];
    };
  };
  manuals: {
    asset: { url: string };
  }[];
}

const ProductDetails = ({ block, manuals = [], data }: ProductDetailsProps) => {
  if (!block) return null;

  return (
    <section {...generateId(block)} className="my-10 flex flex-col gap-4">
      {block?.contentBlocks?.map(contentBlock => (
        <div
          key={contentBlock._key}
          className="rounded-lg bg-none md:bg-muted p-0 md:p-4 [&_a]:foreground-link md:[&_a]:muted-foreground-link"
        >
          <h2>{contentBlock?.headline}</h2>
          {contentBlock.image && (
            <div className="justify-center">
              <img
                src={contentBlock?.image?.asset?.url}
                alt={contentBlock?.image?.asset?.alt || ''}
              />
            </div>
          )}

          {contentBlock?.contentType === 'html' ? (
            <div className="w-full overflow-x-scroll show-scroll-bars">
              <div
                id={contentBlock?._key}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: contentBlock?.html }}
              />
            </div>
          ) : (
            <RichText body={contentBlock?.block} />
          )}
        </div>
      ))}

      {!block.supportBlockDisabled && (
        <SupportCard
          manuals={manuals}
          warnings={data?.product?.warnings}
          warranties={data?.product?.warranties}
          supportPage={data?.product?.supportPage}
        />
      )}
    </section>
  );
};

export default ProductDetails;
